<script lang="ts">
  import type StatamicAsset from "@customTypes/statamic.d.ts";
  import type ButtonBlockProps from "@blocks/Buttons/ButtonBlock.svelte";
  import ThemeCard from "@components/content/CardV2/ThemeCard.svelte";
  import { convertStatamicAssetToCDN } from "@utils/cdn";

  export let featured_image: StatamicAsset;
  export let leader: string;
  export let title: string;
  export let description: string;
  export let button: ButtonBlockProps;
  export let href: string;
</script>

<ThemeCard
  featuredImageSrc={convertStatamicAssetToCDN(featured_image.id)}
  {leader}
  {title}
  {description}
  {button}
  {href}
/>
